import React from "react";
import { render } from "react-dom";
import JourneyPlanner from "./components/JourneyPlanner";

if (document.getElementsByClassName("journey-planner-widget")) {
  const el = [].slice.call(
    document.getElementsByClassName("journey-planner-widget")
  );
  el.forEach(e => {
    render(<JourneyPlanner />, e);
  });
}
